"use strict"; // Generated using scripts/write-decode-map.ts

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = new Uint16Array( // prettier-ignore
"\u0200aglq\t\x15\x18\x1B\u026D\x0F\0\0\x12p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map(function (c) {
  return c.charCodeAt(0);
}));